import { useEffect } from 'react';
import { FaHome, FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight, FaFileExcel } from 'react-icons/fa';
import ledger1 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IE-2470_110_PDP_Machine_Ledger.xls';
import ledger2 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IE-2470-111_PAC_Machine_Ledger.xlsx';
import ledger3 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IE-2470-112_SP_Machine_Ledger.xlsx';
import ledger4 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IE-2470-113_TP1_Machine_Ledger.xlsx';
import ledger5 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IE-2470-114_TP2_Machine_Ledger.xlsx';
import ledger6 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IE-2470-510_HMI_Machine_Ledger.xlsx';
import ledger7 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IE-9030-201_Ethernet_Assembly_Machine_Ledger.xlsx';
import ledger8 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IIE-2470-810_Install_Machine_Ledger.xlsx';
import ledger9 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-201_Universal_Camera_Mounting_Assy_Machine_Ledger.xlsx';
import ledger10 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-202_Universal_Camera_Mounting_Assy_Machine_Ledger.xlsx';
import ledger11 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-203_Universal_Camera_Mounting_Assy_Machine_Ledger.xlsx';
import ledger12 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-204_Universal_Camera_Mounting_Assy_Machine_Ledger.xlsx';
import ledger13 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-205_Universal_Camera_Mounting_Assy_Machine_Ledger.xlsx';
import ledger14 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-221_Universal_Camera_Mounting_Assy_Machine_Ledger.xlsx';
import ledger15 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-222_Universal_Camera_Mounting_Assy_Machine_Ledger.xlsx';
import ledger16 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-600_Lights_Position_Machine_Ledger.xlsx';
import ledger17 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-700_Lights_Position_Machine_Ledger.xlsx';
import ledger18 from '../../../routes/SmartInspect/Warren/Maintenance/ledgers/Smart_Inspect_IO-2470-2100_Universal_Mounting_Assy_Machine_Ledger.xlsx';
import $ from 'jquery';
import styled from 'styled-components';

const TableComp = ({ className, tablesorter }) => {
	useEffect(() => {
		$('#myTable')
			.tablesorter({
				theme: 'ice',
				widgets: ['filter', 'zebra', 'cssStickyHeaders', 'pager'],
				widgetOptions: { cssStickyHeaders_attachTo: '.table-container', uitheme: 'jui' },
			})
			.tablesorterPager({
				// target the pager markup - see the HTML block below
				container: $('.pager'),

				// output string - default is '{page}/{totalPages}';
				// possible variables:
				// {page}, {totalPages}, {startRow}, {endRow} and {totalRows}
				output: '{page}/{totalPages} ({startRow}-{endRow})',

				// apply disabled classname to the pager arrows when the rows at
				// either extreme is visible - default is true
				updateArrows: true,

				// starting page of the pager (zero based index)
				page: 0,

				// Number of visible rows - default is 10
				size: 10,

				// if true, the table will remain the same height no matter how many
				// records are displayed. The space is made up by an empty
				// table row set to a height to compensate; default is false
				fixedHeight: true,

				// remove rows from the table to speed up the sort of large tables.
				// setting this to false, only hides the non-visible rows; needed
				// if you plan to add/remove rows with the pager enabled.
				removeRows: false,

				// css class names of pager arrows
				// next page arrow
				cssNext: '.next',
				// previous page arrow
				cssPrev: '.prev',
				// go to first page arrow
				cssFirst: '.first',
				// go to last page arrow
				cssLast: '.last',
				// select dropdown to allow choosing a page
				cssGoto: '.gotoPage',
				// location of where the "output" is displayed
				cssPageDisplay: '.pagedisplay',
				// dropdown that sets the "size" option
				cssPageSize: '.pagesize',
				// class added to arrows when at the extremes
				// (i.e. prev/first arrows are "disabled" when on the first page)
				// Note there is no period "." in front of this class name
				cssDisabled: 'disabled',
			});
	});
	let classes = { className };
	if (tablesorter) {
		classes += 'tablesorter';
	}

	return (
		<table id="myTable" class={classes} style={{ width: '100%' }}>
			<thead>
				<tr>
					<th>Name</th>
					<th>Ledger</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>IE-2470-110 PDP</td>
					<td>
						<a target="blank" href={ledger1}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IE-2470-111 PAC</td>
					<td>
						<a target="blank" href={ledger2}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IE-2470-112 SP</td>
					<td>
						<a target="blank" href={ledger3}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IE-2470-113 TP1</td>
					<td>
						<a target="blank" href={ledger4}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IE-2470-114 TP2</td>
					<td>
						<a target="blank" href={ledger5}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IE-2470-510 HMI</td>
					<td>
						<a target="blank" href={ledger6}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IE-9030-201 Ethernet Assembly</td>
					<td>
						<a target="blank" href={ledger7}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IIE-2470-810 Install</td>
					<td>
						<a target="blank" href={ledger8}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-201 Universal Camera Mounting Assembly</td>
					<td>
						<a target="blank" href={ledger9}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-202 Universal Camera Mounting Assembly</td>
					<td>
						<a target="blank" href={ledger10}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-203 Universal Camera Mounting Assembly</td>
					<td>
						<a target="blank" href={ledger11}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-204 Universal Camera Mounting Assembly</td>
					<td>
						<a target="blank" href={ledger12}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-205 Universal Camera Mounting Assembly</td>
					<td>
						<a target="blank" href={ledger13}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-221 Universal Camera Mounting Assembly</td>
					<td>
						<a target="blank" href={ledger14}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-222 Universal Camera Mounting Assembly</td>
					<td>
						<a target="blank" href={ledger15}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-600 Lights Position</td>
					<td>
						<a target="blank" href={ledger16}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-700 Lights Position</td>
					<td>
						<a target="blank" href={ledger17}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>IO-2470-2100 Universal Mounting Assembly</td>
					<td>
						<a target="blank" href={ledger18}>
							<FaFileExcel size={50} class="file-link" />
						</a>
					</td>
				</tr>
			</tbody>
			<tfooter id="pager" className="pager" style={{}}>
				<form>
					<FaAngleDoubleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="first" alt="button" />
					<FaAngleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="prev" alt="button" />
					<input type="text" className="pagedisplay" alt="button" />
					<FaAngleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="next" alt="button" />
					<FaAngleDoubleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="last" alt="button" />
					<select className="pagesize">
						<option selected="selected" value="10">
							10
						</option>
						<option value="20">20</option>
						<option value="30">30</option>
					</select>
				</form>
			</tfooter>
		</table>
	);
};

const Table = styled(TableComp)``;

export default Table;
